import {
  abTestEvents,
  aiRewriteEvents,
  apiEvents,
  audioDownloadEvents,
  bannerSidebarEvents,
  demoProjectsTrial,
  feedbackEvents,
  lipSyncEvents,
  miscEvents,
  multilanguageEvents,
  onboardingEvents,
  paywallEvents,
  platformEvents,
  pricingEvents,
  projectEvents,
  sidebarEvents,
  signUpEvents,
  srtDownloadEvents,
  srtEditorEvents,
  srtUploadEvents,
  subscriptionEvents,
  subtitlesBurningEvents,
  teamspacesEvents,
  trialShareEvents,
  uploadVideoEvents,
  videoPlayerEvents,
  voiceEvents,
} from './events';
import { advancedToolsEvents } from './events/advancedToolsEvents';
import { glossaryEvents } from './events/glossaryEvents';
import { userPromptingEvents } from './events/userPromptingEvents';
import { trackEvent } from './mixpanelMethods';

export const EVENTS = [
  ...pricingEvents,
  ...paywallEvents,
  ...onboardingEvents,
  ...srtUploadEvents,
  ...apiEvents,
  ...aiRewriteEvents,
  ...multilanguageEvents,
  ...srtEditorEvents,
  ...subscriptionEvents,
  ...lipSyncEvents,
  ...subtitlesBurningEvents,
  ...platformEvents,
  ...signUpEvents,
  ...uploadVideoEvents,
  ...videoPlayerEvents,
  ...feedbackEvents,
  ...miscEvents,
  ...voiceEvents,
  ...audioDownloadEvents,
  ...srtDownloadEvents,
  ...glossaryEvents,
  ...bannerSidebarEvents,
  ...abTestEvents,
  ...projectEvents,
  ...sidebarEvents,
  ...demoProjectsTrial,
  ...teamspacesEvents,
  ...userPromptingEvents,
  ...trialShareEvents,
  ...advancedToolsEvents,
];

type EventNames = (typeof EVENTS)[number]['eventName'];

type EventPayload = {
  [key: string]: boolean | number | string;
};

type Event = {
  [key in EventNames]: (payload?: EventPayload) => void;
};

type MixpanelEvent = {
  eventName: EventNames;
  shouldSendRaskTTSData?: boolean;
  shouldSendSubscriptionData?: boolean;
};

export const getEvents = (events: MixpanelEvent[]) => {
  return events.reduce((acc, event) => {
    const { eventName, shouldSendRaskTTSData, shouldSendSubscriptionData } = event;

    return {
      ...acc,
      [eventName]: (properties?: EventPayload) =>
        trackEvent({
          eventName,
          metadata: { shouldSendRaskTTSData, shouldSendSubscriptionData },
          properties,
        }),
    };
  }, {} as Event);
};

export const MixpanelEvents = getEvents(EVENTS);

export { initMixpanel, setMixpanelUser, setMixpanelUserProperty, shutdownMixpanel } from './mixpanelMethods';

export { resetMixpanelProps, useMixpanelPropsStore } from './useMixpanelPropsStore';
